module.exports = __webpack_public_path__ + "media/images/home/3-8cec33610b883de81724817ba6c0e30f.png";